import {
    createRosterProviderAppClients,
    createRosterProviderAppWriteClients,
    MockRosterDataSource,
    ProviderAppRosterDataSource,
    RosterDataSource,
    ROSTER_PROVIDER_APP_CAPABILITIES,
    RosterStore,
} from '@enter/core';

/**
 * The provider app's Roster store: role `client` (the design's client admin — the ops-only columns
 * and controls are hidden), on the provider API. Everything the design has is wired to its
 * `/provider/…` route, including the ones the API does not have yet (see
 * `ROSTER_PROVIDER_APP_CAPABILITIES`), so the ones that fail say so.
 *
 * In demo mode nothing may reach the API or render real data (NS-14), so the generated roster is
 * the source — the demo boundary would refuse the requests anyway. `REACT_APP_ROSTER_DATA_SOURCE=mock`
 * picks it too, as in the support app, for working on the screen without an account.
 */
export function createProviderRosterStore(isDemo: boolean): RosterStore {
    const dataSource: RosterDataSource =
        isDemo || process.env.REACT_APP_ROSTER_DATA_SOURCE === 'mock'
            ? // Generated records, offering only what the provider API can do (NS-4).
              new MockRosterDataSource({ capabilities: ROSTER_PROVIDER_APP_CAPABILITIES })
            : new ProviderAppRosterDataSource(createRosterProviderAppClients(), createRosterProviderAppWriteClients());
    return new RosterStore({ dataSource, role: 'client' });
}
